<template>
  <div>
    <div v-if="showReportListComponent">
      <page-header class="mt-6 lg:mt-0" :full-width="true">
        <div class="flex flex-wrap -mx-2">
          <div class="w-full px-2">
          </div>
        </div>
      </page-header>

      <div class="w-full flex flex-wrap">
        <div class="flex flex-col w-1/6 pr-2 mb-4 justify-end">
          <label for="keywords" class="flex flex-row mb-2">Search</label>
          <input id="keywords" type="text" v-model="keywords" placeholder="Report Name"
               class="bg-white rounded h-10 py-0 px-2 shadow text-sm border"/>
        </div>
      </div>
      <panel class="mt-5 pt-6" v-if="!loading && reports && reports.length > 0">
        <div class="w-full max-w-full overflow-x-auto overflow-y-hidden">
          <table class="table-auto text-center w-full">
            <thead class="uppercase text-xs">
            <tr>
              <th class="text-left p-2 whitespace-no-wrap">
                Report Name
              </th>
              <th class="p-2 whitespace-no-wrap">
                Created
              </th>
              <th class="p-2 whitespace-no-wrap">
                No. of Properties
              </th>
              <th class="p-2 whitespace-no-wrap">
                Digital Report
              </th>
              <th class="p-2 whitespace-no-wrap">
                Pdf
              </th>
              <th class="p-2 whitespace-no-wrap">
                Edit
              </th>
              <th class="p-2 whitespace-no-wrap">
                Delete
              </th>
            </tr>
            </thead>
            <tbody class="text-sm">
            <tr v-for="(report, i) in reports" :key="i"
                class="border-t border-grey-lighter hover:bg-grey-lightest cursor-pointer">
              <td class="text-left p-2 font-bold">{{ report.title }}</td>
              <td class="p-2">{{ report.created_at | datetime }}</td>
              <td class="p-2">{{ report.property_count }}</td>
              <td class="p-2" @click="showReport(report.id)"><i class="fas fa-link"></i></td>
              <td class="p-2">
                <loader v-if="downloadingProperties.includes(report.id)" :fillColor="'grey'"/>
                <span v-else>
                  <i class="fas fa-file-pdf" @click="downloadPDF(report.id)"></i>
                </span>
              </td>
              <td class="p-2"><i class="fas fa-pencil-alt cursor-pointer" @click="editReport(report.id)"></i></td>
              <td class="p-2"><i class="fas fa-trash" @click="deleteReport(i)"></i></td>
            </tr>
            </tbody>
          </table>
        </div>
      </panel>

      <panel v-if="!loading && reports && reports.length === 0" class="mt-5 pt-6">
        <strong class="mb-2">No Reports</strong>
        <p>Your search returned no results</p>
      </panel>
      <div v-if="loading" class="w-full h-screen text-center">
        <loader></loader>
      </div>
    </div>
    <div v-if="showDigitalListComponent">
      <property-comparison-report :selectedReportId="selectedReportId" @updateComponentVisibility="updateComponentVisibility"/>
    </div>
    <div v-if="showEditComponent">
      <property-comparison-page class="mt-4" :editReportId="editReportId" @updateComponentVisibility="updateComponentVisibility" />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import api from '@/http'
import PropertyComparisonReport from '@/views/property/PropertyComparisonReport.vue'
import PropertyComparisonPage from '@/views/property/PropertyComparisonPage.vue'

export default {
  name: 'PropertyComparisonPreviousReport',

  data () {
    return {
      keywords: '',
      results: {},
      loading: false,
      saving: false,
      magazineAlert: null,
      pageHasChanged: false,
      loadingStats: false,
      selectedProperties: [],
      newReport: {
        id: '',
        title: '',
        error: ''
      },
      downloadingProperties: [],
      showReportListComponent: true,
      showDigitalListComponent: false,
      showEditComponent: false,
      selectedReportId: null,
      editReportId: 0
    }
  },
  components: {
    PropertyComparisonReport,
    PropertyComparisonPage
  },
  computed: {
    ...mapState(['system', 'selectedOffice']),
    reports: function () {
      /*
      if (!this.results || !this.results.data) {
        return []
      }
      return this.results.data.filter(report => report.indexOf(this.keywords) !== -1)
      */
      return this.results
    }
  },
  methods: {
    ...mapActions(['displayToastNotification', 'setPageLoading']),
    getReports () {
      api.get(`/properties-comparison-report/${this.selectedOffice.id}`, {
        keywords: this.keywords
      }).then((response) => {
        this.results = response.data
        this.loading = false
      }, () => {
        // Error
        this.loading = false
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Internal Server Error',
          info: 'Whoops! Looks like something went wrong.'
        })
      })
    },
    goToProperty (id) {
      this.$router.push(`/property-management/${id}`)
    },
    goToReportList () {
      this.$router.replace('/property-comparison-page')
    },
    pageChanged (i) {
      this.searchParams.page = i
      this.pageHasChanged = true
      this.search()
    },
    showReport (reportId) {
      this.selectedReportId = reportId
      this.showDigitalListComponent = true
      this.showReportListComponent = false
      this.showEditComponent = false
    },
    editReport (reportId) {
      this.editReportId = reportId
      this.showDigitalListComponent = false
      this.showReportListComponent = false
      this.showEditComponent = true
      // this.$router.push({ name: 'propertycomparisonpage', params: { reportId: reportId } })
    },
    deleteReport (index) {
      let result = confirm('Do you want to delete report ' + this.reports[index].title + '?')
      if (result) {
        api.delete(`/properties-comparison-report/${this.reports[index].id}`).then((response) => {
          this.results.splice(index, 1)
          this.loading = false
        }, () => {
          // Error
          this.loading = false
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'Internal Server Error',
            info: 'Whoops! Looks like something went wrong.'
          })
        })
      }
    },
    downloadPDF (reportId) {
      console.log(this.downloadingProperties.push(reportId))
      this.downloadingProperties.push(reportId)
      api
        .post(`/properties-comparison-report/${reportId}/download-pdf`)
        .then(
          response => {
            var url = response.data
            window.open(url, '_blank').focus()
            let index = this.downloadingProperties.indexOf(reportId)
            if (index !== -1) {
              this.downloadingProperties.splice(index, 1)
            }
          },
          () => {
            this.displayToastNotification({
              type: 'danger',
              icon: 'fa-times-circle',
              title: 'Internal Server Error',
              info: 'Whoops! Looks like something went wrong.'
            })
          }
        )
      let index = this.downloadingProperties.indexOf(reportId)
      if (index !== -1) {
        this.downloadingProperties.splice(index, 1)
      }
    },
    updateComponentVisibility () {
      this.showReportListComponent = true
      this.showDigitalListComponent = false
      this.showEditComponent = false
      this.getReports()
    }
  },
  mounted () {
    this.getReports()
  }
}
</script>
<style scoped>
  .icon-img {
    background-size: cover;
    background-position: center;
  }

  .icon {
    width: 80px;
    height: 60px;
  }
</style>
